import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./AdminLogin";
import AdminLayout from "./AdminLayout";
import AdminDashboard from "./AdminDashboard";
import AdminLeads from "./AdminLeads";
import AdminCustomizer from "./AdminCustomizer";
import AdminEditor from "./AdminEditor";
import AdminMaintenance from "./AdminMaintenance";

export default function AdminApp() {
  useEffect(() => {
    document.documentElement.classList.remove("sd-preloading");
    document.documentElement.style.backgroundColor = "";
    document.body.style.backgroundColor = "";
    const root = document.getElementById("root");
    if (root) root.style.backgroundColor = "";
  }, []);

  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="leads" element={<AdminLeads />} />
        <Route path="content" element={<AdminCustomizer />} />
        <Route path="maintenance" element={<AdminMaintenance />} />
        <Route path="json" element={<AdminEditor />} />
      </Route>
    </Routes>
  );
}
